export default "__VITE_ASSET__BEuIwbAT__"